/** Handle the Navigation display logic for the home page
 * Check the home page; get the param and display nav in the home page
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Container
import ContentToggle from './ContentToggle';
import NavDropDown from './NavDropDown';

// Helpers.
import Page from '../../lib/page';

/**
 * isLoggedIn to control Home page dislay logic
 * TODO: removed after adding technical tag.
 * @type {Boolean}
 */
const isLoggedIn = Page.isLoggedIn();

class NavHome extends Component {
  render() {
    if (!Page.checkPageInPath(this.props.pathname)) {
      return null;
    }
    return (
      <div className="nav-home-container">
        {Page.isToggleTreatment() ? <ContentToggle display={!isLoggedIn} /> : <NavDropDown />}
      </div>
    );
  }
}

// NavHome Props Types
NavHome.propTypes = {
  pathname: PropTypes.string,
};

// NavHome Props default values
NavHome.defaultProps = {
  pathname: '',
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    pathname: state.location.pathname,
  };
}

// export default NavHome;
export default connect(mapStateToProps)(NavHome);



// WEBPACK FOOTER //
// ./home/containers/NavHome.js